import { toHHmmss } from './time-utils';

/**
 * To get the enum key from the value
 */
export const getEnumKeyByValue = <T extends Record<string, number | string | undefined>>(
  enumObject: T,
  value?: number | string
): string => {
  if (value) {
    for (const key in enumObject) {
      if (enumObject[key] === value || enumObject[key] === parseInt(value as string)) {
        return key;
      }
    }
  }
  return '';
};

export const parseTranscript = (transcript: string, tokens?: Record<string, string | undefined>) => {
  const regex = /\[(.*?)\] <(.*?) --> (.*?)> (.+?)\n/g;
  const result = [];
  let match;

  while ((match = regex.exec(transcript)) !== null) {
    const time = {
      start: toHHmmss(parseFloat(match[2]), true),
      end: toHHmmss(parseFloat(match[3]), true),
    };
    const speaker = match[1];
    const text = match[4];

    result.push({ time, speaker, text: !tokens ? text : parseTranscriptWithTokens(text, tokens) });
  }

  return result;
};

export const parseTranscriptWithTokens = (transcript: string, tokens: Record<string, string | undefined>): string => {
  if (!transcript) {
    return '';
  }
  return transcript.replace(/\[([^\]]+)\]/g, (match, p1) => tokens[p1] || match);
};
